import React, { useState, useEffect } from "react";
import "./Compliance.scss";

import Calendar from "../../images/calendar.svg";
import Wallet from "../../images/wallet-16.svg";
import TransactionTable from "../../components/TransactionTable/TransactionTable";
import {
  TransactionAudit,
  TransactionAuditCities,
  TransactionAuditCorridors,
  TransactionAuditFlipping,
  getGlobalTransactionSplitting,
  getGlobalTransactionStatus,
  getGlobalPurpose,
  getGlobalOccupations,
  getGlobalIncompleteAddress,
} from "../../util/API/Compliance";
import { CSVLink } from "react-csv";
import CSVImage from "../../images/csv-file.png";
import TransactionFilterModal from "../../components/TransactionFilterModal/TransactionFilterModal";

function Compliance() {
  const [selectedOption, setSelectedOption] = useState("all");
  const [transactionAuditData, setTransactionAuditData] = useState([]);
  const [view, setView] = useState("all");
  const [loading, setLoading] = useState(true);
  const [title, setTitle] = useState("All");
  const [open, setOpen] = useState(false);
  const [timeRange, setTimeRange] = useState("All");
  const [filteredData, setFilteredData] = useState([]);
  const handleOpen = (data, fullData) => {
    setOpen(true);
    // setSelectedData(data);
    // setfullSelectedData(fullData);
  };
  const handleClose = () => setOpen(false);

  //This useEffect is used to get the data from the API and set it to the state based on the select dropdown of what type of transactions
  useEffect(() => {
    const getData = async () => {
      let transactionAuditData;

      switch (view) {
        case "all":
          transactionAuditData = await TransactionAudit();
          setTitle("All");
          break;
        case "cities":
          transactionAuditData = await TransactionAuditCities(
            "Pretoria/Durban/Johannesburg/Port Elizabeth/Cape Town"
          );
          setTitle("High Crime Cities");
          break;
        case "corridors":
          transactionAuditData = await TransactionAuditCorridors();
          setTitle("Receiving Corridors");
          break;
        case "flipping":
          transactionAuditData = await TransactionAuditFlipping();
          setTitle("Transaction Flipping");
          break;
        case "splitting":
          transactionAuditData = await getGlobalTransactionSplitting();
          setTitle("Transaction Splitting");
          break;
        case "purpose":
          transactionAuditData = await getGlobalPurpose();
          setTitle("Purpose Of Transaction");
          break;
        case "occupation":
          transactionAuditData = await getGlobalOccupations();
          setTitle("Sender / Receiver Occupation");
          break;
        case "address":
          transactionAuditData = await getGlobalIncompleteAddress();
          setTitle("Incomplete address");
          break;
        case "status":
          transactionAuditData = await getGlobalTransactionStatus();
          setTitle("Transaction Status");
          break;
        case "otm":
          transactionAuditData = await TransactionAudit();
          const otmTransactions = transactionAuditData.data.record.filter(
            (entry) => entry.transactionaudit.amlrule == "1"
          );
          setTransactionAuditData(otmTransactions);
          setTitle("One to Many");
          break;
        case "mto":
          transactionAuditData = await TransactionAudit();
          const mtoTransactions = transactionAuditData.data.record.filter(
            (entry) => entry.transactionaudit.amlrule === "2"
          );
          setTransactionAuditData(mtoTransactions);
          setTitle("Many to One");
          break;
        default:
          break;
      }

      //Checks for one to many or money to one
      if (transactionAuditData.data && view != "otm" && view != "mto") {
        if (transactionAuditData.data.record.length != undefined) {
          setTransactionAuditData(transactionAuditData.data.record);
        } else {
          setTransactionAuditData([transactionAuditData.data.record]);
        }
      } else if (view === "otm" || view === "mto") {
      } else {
        setTransactionAuditData([]);
      }

      let filteredData = filterDataByTimeRange(
        transactionAuditData.data.record,
        timeRange
      );
      setFilteredData(filteredData);

      setLoading(false);
    };

    // const filterData = async () => {
    //   let filteredData = filterDataByTimeRange(transactionAuditData, timeRange);
    //   setFilteredData(filteredData);
    // };
    // filterData();

    getData();
  }, [view, timeRange]);

  const setFilteredTransaction = (data) => {
    setTransactionAuditData(data);
  };

  const handleViewChange = (e) => {
    setView(e.target.value);
  };

  const getParsedData = (data) => {
    try {
      return JSON.parse(data.replace(/&quot;/g, '"')).record;
    } catch (e) {
      console.error("Error parsing data:", e);
      return {};
    }
  };

  //Date filtering logic here

  const handleTimeRangeChange = (e) => {
    setTimeRange(e.target.value);
  };

  //Logic to filter it based on the date and time range
  const filterDataByTimeRange = (data, range) => {
    const now = new Date();
    return data.filter((item) => {
      const transactionDate = new Date(item.transactionaudit.datetime);
      switch (range) {
        case "Day":
          return transactionDate.toDateString() === now.toDateString();
        case "Week":
          const oneWeekAgo = new Date(
            now.getFullYear(),
            now.getMonth(),
            now.getDate() - 7
          );
          return transactionDate > oneWeekAgo;
        case "Month":
          const oneMonthAgo = new Date(
            now.getFullYear(),
            now.getMonth() - 1,
            now.getDate()
          );
          return transactionDate > oneMonthAgo;
        default:
          return true;
      }
    });
  };

  useEffect(() => {}, [view, timeRange]);

  //Printing a CSV is done below
  // Add your title here
  const titleRow = [`Transaction Report for ${view}`];
  //function written to give total amount from filtered results

  const csvData = [
    // Add the title row as the first row
    titleRow,
    // Add an empty row to separate the title from the header
    [],
    // These will be header columns
    [
      "Reference No.",
      "Face Amount(R)",
      "Sender Local Currency Amount",
      "Sender Local Currency Code",
      "Send Date",
      "Sender First Name",
      "Sender Middle Name",
      "Sender Last Name",
      "Sender Maternal Name",
      "Sender Address1",
      "Sender Address2",
      "Sender Address3",
      "Sender City",
      "Sender Province",
      "Sender Country",
      "Sender Phone Number",
      "Birth Date",
      "Photo Id",
      "Photo Id Type",
      "Receiver First Name",
      "Receiver Last Name",
      "Sender Agent Name",
      "Sender Agent Country",
      "Receiver Agent Country",
      "Occupation",
      "Purpose Of Transaction",
      "Source Of Funds",
      "Relationship With Receiver",
      "Current Transaction Status",
    ],
    ...filteredData.map((row) => {
      const parsedData = getParsedData(row.transactionaudit.sourcedata);

      return [
        parsedData.ReferenceNumber,
        parsedData.faceAmount,
        parsedData.senderLocalCurrencyAmount,
        parsedData.senderLocalCurrencyCode,
        parsedData.sendDate,
        parsedData.senderFirstName,
        parsedData.senderMiddleName,
        parsedData.senderLastname,
        parsedData.senderMaternalName,
        parsedData.senderAddress1,
        parsedData.senderAddress2,
        parsedData.senderAddress3,
        parsedData.senderCity,
        parsedData.senderProvince,
        parsedData.senderCountry,
        parsedData.senderPhoneNumber,
        parsedData.BirthDate,
        parsedData.photoID,
        parsedData.photoIDType,
        parsedData.receiverFirstName,
        parsedData.receiverLastName,
        parsedData.senderAgentName,
        parsedData.senderAgentCountry,
        parsedData.receiverAgentCountry,
        parsedData.recipientOccupation,
        parsedData.purposeOfTransaction,
        parsedData.sourceOfFunds,
        parsedData.relationshipWithReceiver,
        parsedData.currenctTransactionStatus,
      ];
    }),
  ];

  return (
    <>
      <TransactionFilterModal
        open={open}
        handleClose={handleClose}
        setFilteredTransaction={setFilteredTransaction}
      />
      <div className="page-container roles-container compliance-container">
        <div className="header-container">
          <div className="page-title">
            <div>Transaction Monitoring </div>
          </div>
        </div>
        {/* <div className="chart-container">
        <div className="compliance-charts">
          <ComplianceChart title={"Transfers"} />
        </div>
        <div className="compliance-charts">
          <ComplianceChart title={"Velocity"} />
        </div>
        <div className="compliance-charts">
          <ComplianceChart title={"Failed Attempts"} />
        </div>
      </div> */}
        <div className="transaction-history">
          <div className="d-flex justify-content-between">
            <p className="transaction-history-title">
              Transaction History - {title}
            </p>
            <CSVLink
              data={csvData}
              filename={`SendIt-Audit-Report-${view}-${Date().slice(
                0,
                15
              )}.csv`}
            >
              <img src={CSVImage} className="csv-image-download mb-3 mt-3" loading="lazy" />
            </CSVLink>
          </div>
          <div className="transaction-option-container">
            <div className="transaction-filter-container">
              <div>
                <div>
                  <label for="time" className="selector-titles">
                    Time Range
                  </label>
                </div>
                <div className="transaction-selector">
                  <img src={Calendar} loading="lazy" />
                  <select
                    name="time"
                    id="time-range"
                    onChange={handleTimeRangeChange}
                  >
                    <option value="All">All</option>
                    <option value="Day">Day</option>
                    <option value="Week">Week</option>
                    <option value="Month">Month</option>
                  </select>
                </div>
              </div>

              {/* <div>
                <div>
                  <label for="time" className="selector-titles">
                    Type
                  </label>
                </div>
                <div className="transaction-selector">
                  <img src={Wallet} />
                  <select name="time" id="time-range">
                    <option value="All">All</option>
                    <option value="Day">Day</option>
                    <option value="Week">Week</option>
                    <option value="Month">Month</option>
                  </select>
                </div>
              </div>
              <div>
                <div>
                  <label for="time" className="selector-titles">
                    Recipients
                  </label>
                </div>
                <div className="transaction-selector">
                  <img src={UserList} />
                  <select name="time" id="time-range">
                    <option value="All">All</option>
                    <option value="Day">Day</option>
                    <option value="Week">Week</option>
                    <option value="Month">Month</option>
                  </select>
                </div>
              </div> */}
              <div>
                <div>
                  <label for="time" className="selector-titles">
                    View
                  </label>
                </div>
                <div className="transaction-selector">
                  <img src={Wallet} loading="lazy" />
                  <select
                    name="time"
                    id="time-range"
                    onChange={handleViewChange}
                    value={view}
                  >
                    <option value="all">All</option>
                    <option value="otm">Transaction One to Many</option>
                    <option value="mto">Transaction Many to One</option>
                    <option value="cities">High Crime Cities</option>
                    <option value="corridors">Receiving Corridors</option>
                    <option value="flipping">Transaction Flipping</option>
                    <option value="status">Transaction Status</option>
                    <option value="splitting">Transaction Splitting</option>
                    <option value="purpose">Transaction Purpose</option>
                    <option value="occupation">
                      Sender / Receiver Occupation
                    </option>
                    <option value="address">Incomplete address</option>
                  </select>
                </div>
              </div>
              {/* <div className="d-flex align-center ">
                <img src={Settings} className="pointer" onClick={handleOpen} />
              </div> */}
            </div>
            {/* <div className="transaction-sent-received">
              <div>
                <label>
                  <input
                    className="transaction-radios"
                    type="radio"
                    value="all"
                    checked={selectedOption === "all"}
                    onChange={handleChange}
                  />
                  All
                </label>
                <label>
                  <input
                    className="transaction-radios"
                    type="radio"
                    value="received"
                    checked={selectedOption === "received"}
                    onChange={handleChange}
                  />
                  Cities
                </label>
                <label>
                  <input
                    className="transaction-radios"
                    type="radio"
                    value="sent"
                    checked={selectedOption === "sent"}
                    onChange={handleChange}
                  />
                  Sent
                </label>
                <label>
                  <input
                    className="transaction-radios"
                    type="radio"
                    value="warning"
                    checked={selectedOption === "warning"}
                    onChange={handleChange}
                  />
                  Warning
                </label>
              </div>
            </div> */}
          </div>
          <div>
            {!loading ? (
              <TransactionTable
                transactionAuditData={filteredData}
                view={view}
              />
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default Compliance;
